/**
* Created by lobin on 2020/6/18.
*/
<template>
  <a-modal v-model="visible" title="提现申请" ok-text="确认" cancel-text="取消" @ok="submit" :confirmLoading="loading">
    <a-alert type="info">
      <div slot="message">
        <div class="title">账户余额：{{ detail.account }}，可提现金额：{{ detail.account - 100 }}，冻结金额：100</div>
      </div>
      <div slot="description">
        <span>提现用户:</span>
        <a-avatar v-if="detail.bindUser" :src="detail.bindUser.headimgurl" size="small" style="margin: 0 5px;" />
        <span v-if="detail.bindUser">{{ detail.bindUser.nickname }}；提现人姓名: {{ detail.bindUserRealName }}</span>
      </div>
    </a-alert>
    <a-form :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }" style="margin-top: 20px;margin-bottom: 0;">
      <a-form-item label="提现金额:">
        <a-input-number id="inputNumber" v-model="value" :min="1" :step="1" :max="5000" style="width: 100%" placeholder="输入正整数并且不能大于5000以及可提现金额" />
        备注：手续费为提现金额的0.6%
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script type="text/babel">
import { companyDetail, createcompanywithdrawal } from '@/api/company';
import { getWxUserDetail } from '@/api/user';

export default {
  data() {
    return {
      visible: false,
      id: '',
      value: '',
      detail: {},
      loading: false,
    };
  },
  methods: {
    async getDetail() {
      const { data } = await companyDetail(this.id);
      const res = await getWxUserDetail(data.bindUser);
      data.bindUser = res.data;
      this.detail = data;
    },
    show(id) {
      this.id = id;
      this.getDetail();
      this.visible = true;
    },
    hideModal() {
      this.visible = false;
    },
    async submit() {
      const { value } = this;
      if (!value) return this.$message.error('输入提现金额');
      this.loading = true;
      const { data } = await createcompanywithdrawal({
        id: this.id,
        amount: this.value,
      });
      this.loading = false;
      if (data) {
        this.$message.success('提交成功');
        setTimeout(() => {
          this.hideModal();
        }, 1000);
      }
    },
  },
};
</script>
